import script from "./FAQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=ts"

import "./FAQ.vue?vue&type=style&index=0&id=4e6b03a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6b03a8"]])

export default __exports__